/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';
import { Fade } from "react-awesome-reveal";
import { ContactForm } from "parts/ContactForm";

import Header from "parts/Header";
import Footer from "parts/Footer";

export default class Partners extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <section className="bg-gray-50 py-16 px-6">
          <Fade direction="down" triggerOnce>
            <div className="container mx-auto text-center max-w-4xl">
              <h1 className="text-5xl font-bold text-theme-blue mb-6">
                Samenwerken met RevOnc
              </h1>
              <p className="text-lg text-gray-600 leading-relaxed mb-8">
                Bij <span className="text-theme-purple font-semibold">RevOnc</span> geloven wij dat samenwerking de sleutel is tot innovatieve en impactvolle oplossingen.
                Wij staan altijd open voor nieuwe partners die samen met ons de zorg voor
                kankerpatiënten naar een hoger niveau willen tillen.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed mb-8">
                Denk jij dat jouw expertise, diensten of ideeën een positieve bijdrage kunnen
                leveren aan onze missie?
                Neem dan contact met ons op via onderstaand formulier. Wij kijken uit
                naar een waardevolle
                samenwerking!
              </p>
            </div>
          </Fade>
        </section>

        {/* Contact Form Section */}
        <section className="flex items-center justify-center bg-white py-10 px-6">
          <div className="w-full max-w-3xl">
            <ContactForm />
          </div>
        </section>

        <Footer />
      </>
    );
  }
}
